export const CREATE_DELIVERY_CHALLAN_RETURN = 'CREATE_DELIVERY_CHALLAN_RETURN';
export const GET_DELIVERY_CHALLAN_RETURNS = 'GET_DELIVERY_CHALLAN_RETURNS';
export const DELIVERY_CHALLAN_RETURN_REQUEST = 'DELIVERY_CHALLAN_RETURN_REQUEST';
export const UPDATE_DELIVERY_CHALLAN_RETURN = 'UPDATE_DELIVERY_CHALLAN_RETURN';
export const DELETE_DELIVERY_CHALLAN_RETURN = 'DELETE_DELIVERY_CHALLAN_RETURN';
export const DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE = 'DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE';
export const SET_CHALLAN_ORDERS = 'SET_CHALLAN_ORDERS';
export const GET_DELIVERY_CHALLAN_RETURN_PAGE = 'GET_DELIVERY_CHALLAN_RETURN_PAGE';
export const DELIVERY_CHALLAN_RETURN_REQUEST_SUCCESS = 'DELIVERY_CHALLAN_RETURN_REQUEST_SUCCESS';